import { render, staticRenderFns } from "./IconLaunch.vue?vue&type=template&id=4975b91c"
import script from "./IconLaunch.vue?vue&type=script&lang=js"
export * from "./IconLaunch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports